import Big from "big.js"

export function formatDate(timestamp: number) {
    const options = { year: "numeric", month: "short", day: "numeric" } as Intl.DateTimeFormatOptions
    return new Intl.DateTimeFormat("en-US", options).format(new Date(timestamp))
}

export function formatNumber(num: Big, option: Intl.NumberFormatOptions = { maximumFractionDigits: 2 }) {
    const roundedNum = num.round(option.maximumFractionDigits, 0)
    return new Intl.NumberFormat(undefined, option).format(roundedNum.toNumber())
}
